import React from 'react';
import { BookOpenIcon, InfoIcon, ShoppingCartIcon, UserCheckIcon } from 'lucide-react';
import type { CoursesCardData } from '../../types/lexce';
interface CoursePlanCardProps {
  card: CoursesCardData;
}
const requirementStyles: Record<string, string> = {
  Core: 'bg-vin-primary/10 text-vin-primary',
  Foundation: 'bg-vin-tertiary/10 text-vin-tertiary',
  Elective: 'bg-vin-secondary/10 text-vin-secondary'
};
export function CoursePlanCard({
  card
}: CoursePlanCardProps) {
  return <section className="overflow-hidden rounded-2xl border border-vin-line bg-white shadow-card" data-id="element-29" data-mp="265xm27i3tnrt">
      <header className="flex items-center gap-3 border-b border-vin-line bg-vin-mist px-4 py-3" data-id="element-30" data-mp="2kubseseqbud4">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-vin-primary text-white" data-id="element-31" data-mp="2g450ojox7tqn">
          <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="1sdr72oqotmty" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-33" data-mp="1nf7kcm49s70j">
          <h3 className="text-[15px] font-semibold text-vin-ink" data-id="element-34" data-mp="1ne4sobz4i0jk">Draft registration plan</h3>
          <p className="truncate text-[12px] text-vin-muted" data-id="element-35" data-mp="zkrt4zl8papa">{card.term}</p>
        </div>
        <span className="shrink-0 rounded-full bg-white px-2 py-0.5 text-[11px] font-semibold text-vin-primary ring-1 ring-vin-line" data-id="element-36" data-mp="13mmsvznivg0y">
          {card.totalCredits} credits
        </span>
      </header>

      <ul className="divide-y divide-vin-line" data-id="element-37" data-mp="1ddhh39kbwpp1">
        {card.courses.map(course => <li key={course.code} className="px-4 py-3" data-id="element-38" data-mp="gngrx9g1s777">
            <div className="flex items-baseline gap-2" data-id="element-39" data-mp="gp1qda5hgaac">
              <span className="text-[13px] font-bold text-vin-primary" data-id="element-40" data-mp="kplly9aer5ud">{course.code}</span>
              <span className={`rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${requirementStyles[course.requirement]}`} data-id="element-41" data-mp="pndmtst162ap">
                {course.requirement}
              </span>
              <span className="ml-auto text-[11px] font-medium text-vin-muted" data-id="element-42" data-mp="212k7b5t13qv5">{course.credits} cr</span>
            </div>
            <p className="mt-0.5 text-[13px] font-semibold leading-5 text-vin-ink" data-id="element-43" data-mp="263q2rbe2ps8d">{course.name}</p>
            <p className="text-[11px] text-vin-muted" data-id="element-44" data-mp="1gfkm2ak785t0">{course.slot}</p>
            <p className="mt-1 text-[12px] leading-4 text-vin-tertiary" data-id="element-45" data-mp="1be52kmxo67cq">{course.reason}</p>
          </li>)}
      </ul>

      <div className="border-t border-vin-line px-4 py-3" data-id="element-46" data-mp="1q9kx0t25w59n">
        <p className="flex gap-2 rounded-xl bg-vin-mist px-3 py-2 text-[12px] leading-4 text-vin-muted" data-id="element-47" data-mp="1le5lw8vjgngx">
          <InfoIcon className="mt-px h-3.5 w-3.5 shrink-0 text-vin-tertiary" aria-hidden="true" data-id="element-48" data-mp="xnrqq9hnq8i4" />
          {card.caution}
        </p>
        <p className="mt-2 text-[11px] text-vin-muted" data-id="element-49" data-mp="smc96reouk4h">Source: {card.source}</p>

        <div className="mt-4 space-y-2" data-id="element-50" data-mp="17f5y13fuoclt">
          <button type="button" className="flex w-full items-center justify-center gap-2 rounded-xl bg-vin-primary px-4 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-vin-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vin-tertiary" data-id="element-51" data-mp="12ltbcyuqefvp">
            <ShoppingCartIcon className="h-4 w-4" aria-hidden="true" data-id="element-52" data-mp="2lj7q9pj3mwi7" />
            {card.primaryAction}
          </button>
          <button type="button" className="flex w-full items-center justify-center gap-2 rounded-xl border border-vin-line px-4 py-2.5 text-sm font-semibold text-vin-primary transition-colors duration-150 ease-out hover:bg-vin-mist focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vin-tertiary" data-id="element-53" data-mp="2bn4oiks5szvs">
            <UserCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="39892zoyystta" />
            {card.secondaryAction}
          </button>
        </div>
      </div>
    </section>;
}